import { Action } from '../action';
import { AuthType } from '../Auth/action';
import { LabelState } from './state';
import { LabelType } from './action';
import { FilterType } from '../Filter/action';

export const initialState: LabelState = {
    labels: [],
    activeLabel: null,
};

export const labelReducer = (state: LabelState | undefined, action: Action): LabelState => {
    state = state ?? initialState;

    switch (action.type) {
        case LabelType.LabelsLoaded:
            return { ...state, labels: action.labels };
        case LabelType.LabelSelected:
            return { ...state, activeLabel: action.label };
        case FilterType.filterResetRequest:
            return { ...state, activeLabel: null };
        case AuthType.TokenExpired:
            return initialState;
        default:
            return state;
    }
};
